import { useState } from 'react';

const useInput = (defaultValue = '') => {
  const [value, setValue] = useState(defaultValue);

  const onValueChangeHandler = (event) => {
    setValue(event.target.value || event.target.innerHTML);
  };

  return [value, onValueChangeHandler];
};

export default useInput;
